type Direction = 0 | 1;

export const alphaSort = (
  array: string[],
  direction: Direction = 1,
): string[] =>
  array.sort((a, b) => {
    if (a < b) {
      return -1 * direction;
    }

    if (a > b) {
      return 1 * direction;
    }

    return 0;
  });

export const alphaSortBy = <T>(
  array: T[],
  key: keyof T,
  direction: Direction = 1,
): T[] =>
  array.sort((a, b) => {
    const aVal = a?.[key] ?? null;
    const bVal = b?.[key] ?? null;

    if (aVal && bVal) {
      if (aVal < bVal) {
        return -1 * direction;
      }

      if (aVal > bVal) {
        return 1 * direction;
      }
    }

    return 0;
  });

export const moveItem = <T>(list: T[], from: number, to: number): T[] => {
  if (!Number.isInteger(from) || from < 0 || from >= list.length) return list;
  const result = [...list];
  result.splice(to, 0, ...result.splice(from, 1));
  return result;
};
